import { TaxIdBase } from './tax-id-base';

export class MexicoTaxId extends TaxIdBase {
  private readonly LEGAL_ENTITIES_REGEX: RegExp = /^[A-Z&]{3}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[A-Z0-9]{3}$/;
  private readonly INDIVIDUALS_REGEX: RegExp = /^[A-Z&]{4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[A-Z0-9]{3}$/;

  public override isTaxIdValid(taxId: string): boolean {
    const value: string = taxId.trim().toUpperCase();
    return this.LEGAL_ENTITIES_REGEX.test(value) || this.INDIVIDUALS_REGEX.test(value);
  }
}

export const MexicoTaxIdHelper = new MexicoTaxId();
